import React from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { getAllKeys, getDataByKey, removeDataByKey } from '../utils/storage';
import { useFavoriteOpen, useFavorite, useDeals } from '../hooks';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Translate from "../components/Translate";


const useStyles = makeStyles({
    expired: {
        opacity: '0.33'
    },
});

const Favorite = () => {
    const [favoriteOpen, setFavoriteOpen] = useFavoriteOpen();
    const [, setFavorites] = useFavorite();
    const [deals] = useDeals();

    const classes = useStyles();

    const goodKeys = deals.map(deal => deal.dno);

    const remove = (dno) => {
        removeDataByKey(dno);
        setFavorites(getAllKeys());
    }

    const allKeys = getAllKeys();
    const list = allKeys.map(key => {
        const deal = getDataByKey(key);
        const { dname, dimg, dno } = deal;
        const href = `/product?id=${dno}`;
        const expiredClass = clsx({ [classes.expired]: !goodKeys.includes(dno) });
        return (
            <TableRow key={dno}>
                <TableCell align="center" width={70} className={expiredClass}>
                    <a href={href} target="_blank" rel="noreferrer">
                        <img src={dimg} alt={Translate(dname)} style={{ maxHeight: "50px" }} />
                    </a>
                </TableCell>
                <TableCell align="left" width={230} className={expiredClass}>
                    <a href={href} target="_blank" className="favoriteTitle" rel="noreferrer">
                        {Translate(dname)}
                    </a>
                </TableCell>
                <TableCell align="center" width={35}>
                    <Tooltip title="刪除" arrow placement="top-end">
                        <DeleteIcon className="cursor" onClick={() => remove(dno)} />
                    </Tooltip>
                </TableCell>
            </TableRow>
        );
    });

    if (list.length === 0) {
        setFavoriteOpen(false);
    }

    return (<SwipeableDrawer anchor='right' open={favoriteOpen} onClose={() => setFavoriteOpen(false)} onOpen={() => setFavoriteOpen(true)}>
        <TableContainer component={Paper}>
            <Table size="small">
                <TableBody>
                    {list}
                </TableBody>
            </Table>
        </TableContainer>
    </SwipeableDrawer>);
}

export default Favorite;